import { useState } from 'react'

/**
 * モーダルが開いた瞬間に、編集対象の props からフォームの state を作り直す。
 *
 * `useEffect` で初期化すると、開いた最初の 1 フレームだけ前回開いた対象の値が
 * そのまま描画されてちらつく（モーダルは閉じている間もアンマウントされず、
 * state を持ち越すため）。レンダー中に setState を呼べば React はコミット前に
 * 再レンダーするので、DOM には正しい値しか出ない。
 *
 * @param open モーダルの表示状態
 * @param subjectId 編集対象の ID。新規なら null。別の対象に変わったら作り直す
 * @param reset 開いた瞬間に呼ぶ初期化処理。setState だけを行うこと
 */
export function useModalReset(open: boolean, subjectId: string | null, reset: () => void) {
  const [syncedKey, setSyncedKey] = useState<string | null>(null)
  const key = open ? (subjectId ?? 'new') : null
  if (key !== syncedKey) {
    setSyncedKey(key)
    if (open) reset()
  }
}
